// extracted by mini-css-extract-plugin
export default {"items":"item-alignment-options-module__items--BEQBH","itemContainer":"item-alignment-options-module__itemContainer--pSFxD"};